<template>
  <div class="Dialog entry" v-if="state.matches('welcome')">
    <div class="inner">
      <div class="pic-bg"></div>
      <div class="pic-birld"></div>
      <div class="pic-cloud"></div>

      <div class="icon-close" @click="send('CLOSE')"></div>
      <div class="title"><span>概览</span></div>

      <div class="inner-body">
        <img src="../../../../ui/20201111king_double_eleven/assets/banner.png" class="banner">
        <p class="desc">完成任务可得一次免费抽奖机会</p>
        <button class="btn-join" @click="send('CLOSE')">立即参与</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ActivityIntro",
  props: ["state", "send"]
}
</script>

<style scoped>
</style>
